export const constants = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  USER: "user",
  LISTING_ROWLIMIT: 20,
};

// Experian check	NIF/CIF processed	€3.00
// KYC / AML (Entrust)	Entrust responses	€0.50
// Cl@ve documents	Documents downloaded via Cl@ve method	€1.00
// Bank connections (Tink)	Successful Tink bank connections	€0.50

export const THIRD_PARTY_SERVICES = {
  EXPERIAN: { name: "experian", cost: 3.0 },
  TINK: { name: "tink", cost: 0.5 },
  CLAVE: { name: "clave", cost: 1 },
  ENTRUST: { name: "entrust", cost: 0.5 },
};

// Dispatched on window when a skor ticket status is saved so the sidebar
// open-ticket badge can refetch immediately instead of waiting for its poll.
export const SKOR_TICKETS_CHANGED_EVENT = "skor-tickets-changed";
